import { createContext, useContext } from 'react';

export type CreateExperimentationContextValue = {
  openCreateExperimentModal: () => void;
  openCreateMultiArmedBanditModal: () => void;
  initialFlagKey?: string;
};

const CreateExperimentationContext = createContext<CreateExperimentationContextValue>({
  openCreateExperimentModal: () => {},
  openCreateMultiArmedBanditModal: () => {},
});

export const CreateExperimentationProvider = CreateExperimentationContext.Provider;

export function useCreateExperimentationContext(): CreateExperimentationContextValue {
  return useContext(CreateExperimentationContext);
}
